import styled from "styled-components";

export const Header = styled.header`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`;

export const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    padding: 10px;

    background: var(--color-darkNight);
    box-shadow: 2px 2px 0 0 var(--color-peach);
`;

export const Title = styled.h3`
    margin-left: 20px;

    font-weight: normal;
    font-size: 20px;
    line-height: 30px;
`;
